var React = require('react');

function Hangup (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_53110","data-name":"Path 53110","d":"M12.987,11.133l-1.215.684a.766.766,0,0,1-.918-.126L6.8,7.637a.767.767,0,0,1-.126-.918L7.359,5.5A1.149,1.149,0,0,0,7.17,4.128L5.349,2.307a1.149,1.149,0,0,0-1.625,0L2.9,3.133a3.065,3.065,0,0,0-.461,3.744l.415.691a24.026,24.026,0,0,0,8.682,8.5l.082.047a3.071,3.071,0,0,0,3.707-.483l.863-.863a1.149,1.149,0,0,0,0-1.625l-1.822-1.822a1.149,1.149,0,0,0-1.377-.189Z","transform":"translate(-2 -1.97)","fill":"#fff"}));
}

Hangup.defaultProps = {"width":"14.523","height":"14.557","viewBox":"0 0 14.523 14.557"};

module.exports = Hangup;

Hangup.default = Hangup;
